import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import BodmasAddQuestionsTable from './BodmasAddQuestionsTable';
const BodmasAddQuestions = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Add Questions' parent='Add Questions'  />
      <Container fluid={true}>
        <Row>
          <BodmasAddQuestionsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default BodmasAddQuestions;
